module.exports = __webpack_public_path__ + "static/media/noa-ignite-white.54b59cfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/noa-ignite-white.svg
// module id = 562
// module chunks = 0